import { useApp } from '../context/AppContext';
import { trpc } from '../lib/trpc';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { format } from 'date-fns';

export function SubscriptionsScreen() {
    const { selectedBranchId } = useApp();
    const { data: subscriptions, isLoading } = trpc.listSubscriptions.useQuery(
        { branchId: selectedBranchId! },
        { enabled: !!selectedBranchId }
    );

    if (!selectedBranchId) return <div className="p-8 text-center text-muted-foreground">Select a branch.</div>;
    if (isLoading) return <div className="p-8 text-center text-muted-foreground">Loading subscriptions...</div>;

    return (
        <div className="space-y-4 pb-20">
            <h2 className="text-xl font-bold px-1">All Subscriptions</h2>
            {subscriptions?.map(sub => (
                <Card key={sub.id} className="border-0 shadow-sm">
                    <CardHeader className="pb-2">
                        <CardTitle className="text-lg">{sub.user_name}</CardTitle>
                        <CardDescription>
                            Seat {sub.seat_number} • {sub.shift_name}
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        <div className="text-sm font-medium">
                            {format(new Date(sub.start_date), 'd MMM')} – {format(new Date(sub.end_date), 'd MMM yyyy')}
                        </div>
                        {sub.price && (
                            <div className="text-sm text-muted-foreground mt-1">
                                ₹{sub.price}
                            </div>
                        )}
                    </CardContent>
                </Card>
            ))}
            {!subscriptions?.length && (
                <div className="text-center p-8 text-muted-foreground">No subscriptions found.</div>
            )}
        </div>
    );
}
